import styled from 'styled-components'

export default styled.div`
  display: flex;
  font-size: 2rem;
  font-weight: bold;

  button {
    background: transparent;
    outline: none;
    border: 2px solid #000;
    border-radius: 0.5rem;
    padding: 0 0.5rem;
    cursor: pointer;
    transition: 0.2s all ease;
    font-weight: bold;
    font-size: 2rem;
    width: 3rem;
    display: inline-block;

    &:hover {
      background: #e41645;
      color: white;
      border-color: #e41645;
    }
  }

  .value {
    padding: 0 1rem;
    width: 4rem;
    text-align: center;
  }
`
